import { orderedTrafficSourcesForSegments } from "app/Shared/utils";

const supportedTrafficSources = [
    "affiliates",
    "direct",
    "displayAds",
    "email",
    "genAi",
    "internalReferrals",
    "referrals",
    "searchOrganic",
    "searchPaid",
    "socialOrganic",
    "socialPaid",
] as const;

export type SupportedTrafficSource = (typeof supportedTrafficSources)[number];

export const trafficSources = [...supportedTrafficSources].sort(
    (a, b) => orderedTrafficSourcesForSegments.indexOf(a) - orderedTrafficSourcesForSegments.indexOf(b),
);
